/* eslint max-len: ["error", { "code": 120, "tabWidth": 4 }] */
/* eslint-disable node/no-unsupported-features */
import * as types from '../constants/ActionTypes';

export default (state = {username: '', email: '', id: '', groupid: '', groupname: '', logged: false,
                         token: '', isFetching: false, errconn: false, errlogin: false}, action) => {
    switch (action.type) {
        case types.REQUEST_LOGIN:
            return {
                ...state,
                errconn: false,
                errlogin: false,
                isFetching: true,
                logged: false,
            };
        case types.RECEIVE_LOGIN:
            return {
                ...state,
                errconn: false,
                errlogin: false,
                isFetching: false,
                id: action.login.id,
                username: action.login.username,
                email: action.login.email,
                groupid: action.login.groupid,
                groupname: action.login.groupname,
                logged: true,
                token: action.login.token,
            };
        case types.ERROR_LOGIN_CONNECTION:
            return {
                ...state,
                errconn: true,
                errlogin: false,
                isFetching: false,
                logged: false,
            };
        case types.ERROR_LOGIN_LOGIN:
            return {
                ...state,
                errconn: false,
                errlogin: true,
                isFetching: false,
                logged: false,
            };
        case types.RESET_ERROR_LOGIN:
            return {
                ...state,
                username: '',
                email: '',
                id: '',
                groupid: '',
                groupname: '',
                token: '',
                errconn: false,
                errlogin: false,
                isFetching: false,
                logged: false,
            };
        case types.REQUEST_LOGOUT:
            return {
                ...state,
                errconn: false,
                errlogin: false,
                isFetching: false,
                username: '',
                email: '',
                id: '',
                groupid: '',
                groupname: '',
                logged: false,
                token: '',
            };
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/login.js